import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAuth } from '../utils/authStorage';

function ProtectedRoute({ children, allowedRoles }) {
  const auth = getAuth();
  const role = auth?.user?.role;

  if (!auth?.token || !auth?.user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedRoute;

